export enum HandlingUnitEndpoint {
  Base = '/automotive-aftermarket',
  Monitoring = '/monitoring',
  Materials = '/materials',
  Overview = '/overview',
  HandlingUnit = '/handling-unit',
  DeliveryNote = '/delivery-note',
  Statuses = '/statuses',
  Notifications = '/notifications',
}
